import { gameSettings } from "./seed";

// Control characters plus the Unicode line/paragraph separators.
const CONTROL = /[\p{Cc}\u2028\u2029]/u;

export type NicknameCheck = { ok: true; nickname: string; normalized: string } | { ok: false; reason: string };

/** Uniqueness key: NFKC, lower case, whitespace collapsed (SPEC §7). */
export function normalizeNickname(raw: string): string {
  return raw.normalize("NFKC").toLowerCase().replace(/\s+/g, " ").trim();
}

/** Validates a nickname as typed. Length counts Unicode code points after trimming. */
export function checkNickname(raw: string): NicknameCheck {
  const nickname = raw.trim();
  if (CONTROL.test(nickname)) return { ok: false, reason: "Nimimerkissä ei saa olla ohjausmerkkejä." };
  const len = [...nickname].length;
  const { nicknameMinLength: min, nicknameMaxLength: max } = gameSettings;
  if (len < min || len > max) return { ok: false, reason: `Nimimerkin pituus on ${min}–${max} merkkiä.` };
  return { ok: true, nickname, normalized: normalizeNickname(nickname) };
}
